import styled from "styled-components";
import { Button } from "@material-ui/core";

export const ActionButton = styled(Button)`
  background: white;
  color: ${p => p.theme.palette.success.main};
  margin-top: 16px;
`;
